﻿angular.module('cmsModule').controller("CmsController", [function () {
    'use strict';

    const connection = new signalR.HubConnectionBuilder()
        .withUrl("hubs/broadcast")
        .withAutomaticReconnect()
        .build();

    angular.element(function () { //alle touched properties valideren na het laden van form
        connection.start().then(function () {
            console.log("Connected to BroadcastHub");
        }).catch(function (err) {
            return console.error(err.toString());
        });
    });

    connection.on("ReceiveBroadcast", function (broadcasts) {
        const broadcastQueue = [];
        if (Array.isArray(broadcasts) && broadcasts.length > 0) {
            broadcasts.forEach(function (broadcast) {

                const broadcastId = broadcast.Id;

                /// kijk in de localstorage of hier de Id is opgeslagen en
                /// dus of door de gebruiker op "gelezen" is gezet,
                /// of de broadcast een repeatinterval had van 0 en
                /// daarom al in de localstorage is beland.
                if (localStorage.getItem(`broadcast_${broadcastId}`)) {
                    console.log('Broadcast al weergegeven');
                }
                else {
                    broadcastQueue.push(broadcast);
                }
            });
            /// laat alle broadcast zien
            showBroadcasts(broadcastQueue);

            /// hier wordt de localstorage opgeschoond met oude broadcast ids die
            /// nooit meer opgehaald worden uit de database omdat hun tijd
            /// verlopen is.
            for (let i = localStorage.length - 1; i >= 0; i--) {
                const key = localStorage.key(i);
                if (key?.startsWith("broadcast_")) {
                    const storedBroadcastUntilTime = localStorage.getItem(key);
                    const nowDate = new Date();
                    const untilDate = new Date(storedBroadcastUntilTime);
                    if (nowDate > untilDate) {
                        localStorage.removeItem(key);
                    }
                }
            }
        }
    });

    function showBroadcasts(queue) {
        if (queue.length > 0) {
            const broadcast = queue.shift();
            const showGelezenButton = broadcast.RepeatInterval !== 0;
            Swal.fire({
                title: 'Mededeling',
                showConfirmButton: showGelezenButton,
                showCloseButton: true,
                html: broadcast.Message,
                icon: null,
                toast: true,
                confirmButtonText: "Gelezen",
                position: 'top',
                background: 'rgb(255, 171, 64)',
                timer: 0,
                customClass: {
                    popup: 'custom-swal-toast',
                    closeButton: 'custom-swal-close',
                }
            }).then((result) => {
                if (result.isConfirmed || broadcast.RepeatInterval === 0) {
                    /// in dat geval moet ik de broadcast Id opslaan en de eindtijd in de localstorage
                    localStorage.setItem(`broadcast_${broadcast.Id}`, broadcast.ActiveUntil);
                };
                /// en nu de volgende
                showBroadcasts(queue);
            });
        };
    }
}]);